import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'
import { Router, Route } from 'react-router-dom';
import storeProvider from './store/storeProvider';
import App from './app/App';
import whyDidYouRender from '@welldone-software/why-did-you-render'
import './stylesheets/index.scss';
import './stylesheets/colours.scss';

export const store = storeProvider.configureStore();
const persistor = storeProvider.getPersistor();
const history = storeProvider.getHistory();

whyDidYouRender(React);

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <Router history={history}>
                <Route path="/" >
                    <App />
                </Route>
            </Router>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);